export const PanelFieldStatus = {
  UNCHANGED: 'UNCHANGED',
  DIRTY: 'DIRTY',
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
}
